module.exports = __webpack_public_path__ + "img/logo_text.516172e5.png";